import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_GET_FBP);

const _pk_name = "id";

const state = {
    data: [],
    isFetching: false,
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

}

const actions = {
    async fetchAll({ commit }, payload) {
        //console.log("[state/payroll/fbp/fetchAll] Calling API...");
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`);
            commit("setFetching", false);
            //console.log("[state/payroll/fbp/fetchAll] res: ", res);
            if (res.status == 200) {
                commit("set", payload);
            }
            return res;
        } catch {

        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}